module.exports = __webpack_public_path__ + "img/clipboard-attachment.ce57bc4a.svg";